<template>
<BaseModal :id="'associate-selection-modal'" :title="`Inspection Score Report`" :message="message" @close="close($event)">
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template v-slot:content>
        <form class="col-12" @submit.prevent="completeInspection()">
            <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options" :for_update="false"/>
            
            <CentralLiteButtons :save_text="'Done'" />
        </form>
    </template>
</BaseModal>
</template>

<script>
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import CentralLiteButtons from '@/components/CentralLiteButtons'
import FormDynamic from '@/components/FormDynamic'
import BaseModal from "@/components/BaseModal";
import FormResources from "./form_resources";

export default {
    name: "AssociateSelectionModal",

    props: ["breadcrumb", "array_options", "rest_api"],

    components: {
        BaseModal,
        Breadcrumb,
        CentralLiteButtons,
        FormDynamic,
    },

    data() {
        return {
            message: `As this inspection was unscheduled for notification, and no associate has been pre-assigned, choose the associate to receive an email confirming the completion of the inspection.`,
            select_all: false,
            form_format: FormResources.form_format_associate_selection,
            form_data: FormResources.form_data_associate_selection,
            rest_api_search: 'rooms_advanced_search'
        };
    },
    methods: {
        close(event) {
            this.$emit("close", event);
        },

        async completeInspection() {
            this.$emit('complete_inspection',  this.form_data)
        },

    },

    computed: {},

    mounted() {},
};
</script>
